import { render, staticRenderFns } from "./customDashboardGaugeChart.vue?vue&type=template&id=642ee6bb"
import script from "./customDashboardGaugeChart.vue?vue&type=script&lang=js"
export * from "./customDashboardGaugeChart.vue?vue&type=script&lang=js"
import style0 from "./customDashboardGaugeChart.vue?vue&type=style&index=0&id=642ee6bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports